<template>
    <div class="border-top card-body highlight">
        <div class="row">
            <div class="col-12">
                <label class="d-block">Round Up For Ukraine 🇺🇦</label>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="doRoundUp" v-model="doRoundUp">
                    <label v-html="$t('payment_method.round_up.round_up_info', {charityName: roundUp.roundUpCharity.name, amount : store.currencySymbol + roundUp.amount.toFixed(2)})" class="custom-control-label text-muted" for="doRoundUp"></label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions, mapMutations } from "vuex";

    export default {
        computed: {
            ...mapState({
                store: state => state.app.store,
                roundUp: state => state.roundUp
            }),
            doRoundUp:  {
                get: function() {
                    return this.$store.state.payment.doRoundUp;
                },
                set: function(value) {
                    this.setDoRoundUp(value);
                }
            },
        },
        methods: {
            ...mapMutations(['setDoRoundUp'])
        },
        name: "RoundUp"
    }
</script>
<style>
.highlight {
    background: rgba(254,254,254,0.2);
}
</style>
